import api from "./Axios";

export const globalSearch = async (searchQuery) => {
  try {
    const resp = await api.get(
      `/home/globally-search/?search=${encodeURIComponent(searchQuery)}`
    );

    if (resp?.data?.status === 200) {
      return resp?.data?.data;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};
